
import { deepFreeze, toMap } from '@/utils/objUtil'
export {
  copyrightAreaMap,
  languageMap,
  licenseFileType,
  imageType,
  statusIconMap,
} from '@/utils/constants'

const freeze = Object.freeze

export const statusMap = freeze({
  0: '全部',
  1: '待上架',
  2: '已下架',
  3: '审核中',
  4: '不通过',
  5: '已上架',
})

export const attrList = deepFreeze([
  {
    id: 0,
    name: 'MV'
  },
  {
    id: 1,
    name: '影视'
  },
  {
    id: 2,
    name: '动漫'
  },
  {
    id: 3,
    name: '游戏'
  },
  {
    id: 4,
    name: '综艺'
  },
  {
    id: 5,
    name: '戏曲'
  },
  {
    id: 6,
    name: '广告'
  },
  {
    id: 7,
    name: '儿歌'
  },
  {
    id: 8,
    name: '原创'
  },
  {
    id: 9,
    name: '体育'
  },
  {
    id: 10,
    name: '其它'
  },
  {
    id: 11,
    name: '舞蹈'
  }
])

export const attrMap = freeze(toMap(attrList))

// 视频发行地区
export const areaList = deepFreeze([
  {
    id: 0,
    name: '港台'
  },
  {
    id: 1,
    name: '内地'
  },
  {
    id: 2,
    name: '日韩'
  },
  {
    id: 3,
    name: '欧美'
  },
  {
    id: 4,
    name: '其他'
  },
  {
    id: 5,
    name: '东南亚'
  },
  {
    id: 6,
    name: '未知'
  }
])

export const areaMap = freeze(toMap(areaList))

export const srcGenreList = [
  'Pop', 'Classical', 'Jazz', 'Blues', 'Children\'s', 'Country', 'Dance', 'Easy', 'Listening', 'Electronic',
  'Folk', 'Holiday', 'Latin', 'Metal', 'New', 'Age', 'R&b', 'Soul', 'Rap/hip', 'Hop', 'Reggae', 'Rock',
  'Soundtrack', 'World', 'Music', 'Punk', 'Alternative', 'Experimental', 'Spoken&audio', 'Religious'
]

// 版权相关
export const cpSourceMap = {
  1: '免费授权',
  2: '签约上架',
}
export const isAgentMap = {
  0: '自有',
  1: '代理'
}

export const canAuthMap = {
  0: '不可',
  1: '可',
}

export const isOnlyMap = {
  0: '非总代理',
  1: '总代理',
}

export const isOverseaMap = {
  0: '否',
  1: '是',
}

export const acceptList = freeze([
  'video/mp4',
  'video/webm',
  'video/x-flv',
  'video/ogg',
  '.mov',
  '.3gp',
  '.avi',
  '.mkv',
  '.wmv',
  '.mpg',
  '.vob',
  '.flv',
  '.swf',
  '.ocg',
  '.dat',
  '.m4v',
])

export const fieldNameMap = freeze({
  mvName: '视频名称',
  transName: '翻译名称',
  srcVersion: '视频版本',
  upc: 'UPC',
  isrc: 'ISRC',
  desc: '视频简介',
  mvExtend: {
    subTitle: '副标题',
    displayCompanyName: '外显厂牌名称',
    director: '导演',
    editor: '编剧',
    actor: '主演',
    producer: '制片人',

  }
})
